module.exports = __webpack_public_path__ + "img/D2-f.0bc2ca43.jpg";